import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import ImageUploader from 'quill2-image-uploader';
import ImageFormat from 'scaleflow/utils/quill-extenstions/image-format';
import Quill from 'quill';
import imageResizeOptions from 'scaleflow/utils/quill-extenstions/image-resize';
import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';
import { service } from '@ember/service';
import imageUploadHandler from 'scaleflow/utils/quill-extenstions/image-uploader';

Quill.register('formats/image', ImageFormat, true);
registerIfNotRegistered(Quill, 'modules/imageUploader', ImageUploader);
export default class BacklogInitiativesInitiativeNotesController extends Controller {
  @service currentUser;
  @service session;
  @service organisation;
  @service intl;

  queryParams = ['editMode'];

  @tracked editMode = false;

  @action
  handleBonNotesSave(changeset) {
    changeset.save();
    this.toggleEditMode();
  }

  @action
  handleBonNotesCancel(changeset) {
    changeset.rollback();
    this.toggleEditMode();
  }

  get bon() {
    return this.model;
  }

  @action
  setBonDelta(changeset, e) {
    changeset.set('text_delta', e);
  }

  @action
  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  get modules() {
    const modules = {};
    modules.imageUploader = {
      upload: (file) => {
        return imageUploadHandler(
          this.session.idToken,
          this.organisation.id,
          file,
        ).then((s3Link) => {
          return s3Link;
        });
      },
    };
    modules.resize = imageResizeOptions(this.intl);

    let toolbarOptions = [
      ['bold', 'italic', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ['link', 'image', 'clean'], // remove formatting button
    ];
    modules.toolbar = toolbarOptions;
    return modules;
  }
}
